<script lang="ts">
  /*                                                                              */
  /*                                                                                                                      */
</script>

<style lang="scss" global>
  @use "@otto-ec/otto-components-utils/scss/mixins";

  * {
    letter-spacing: unset;
    line-height: unset;
    word-spacing: unset;
  }

  :host {
    @include mixins.no-tap-highlight();
  }
</style>
